export default {"src":"/_next/static/media/lol.d18657f2.svg","height":315,"width":315,"blurWidth":0,"blurHeight":0};